/**
 * Iter53 P32 — ReworkResolveDialog component extras din SaleDetail.js.
 *
 * Dialog cu textarea pentru nota de rezolvare. Note > 5 caractere.
 * La confirmare → callback `onConfirm(note)` (parent face fetch-urile pentru audit + clear-rework).
 */
import { CheckCircle2 } from "lucide-react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "../ui/dialog";

export default function ReworkResolveDialog({
  open, onOpenChange,
  sale,
  note, onNoteChange,
  saving, onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="rework-resolve-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle2 className="h-5 w-5 text-emerald-600" />
            Marchează rezolvat &amp; retrimite spre BO
          </DialogTitle>
          <DialogDescription>
            Adaugă o notă cu rezoluția aplicată. Va fi salvată în Note Backoffice (cu timestamp + user) și auditată separat.
            După confirmare, vânzarea va fi scoasă din Coada de Rework și retrimisă către BO pentru reprocesare.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {sale?.problem_reason_code && (
            <p className="text-sm text-slate-600">
              <span className="font-medium">Motiv inițial:</span>{" "}
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-900">
                {sale.problem_reason_code}
              </span>
            </p>
          )}
          <div>
            <label className="text-sm font-medium text-slate-700">
              Notă rezolvare <span className="text-rose-600">*</span>
            </label>
            <Textarea
              value={note}
              onChange={(e) => onNoteChange(e.target.value)}
              placeholder="Ex: Am corectat CNP-ul după verificare cu actul de identitate. Datele sunt acum valide pentru reprocesare."
              rows={4}
              className="mt-1"
              data-testid="rework-resolve-note-input"
            />
            <p className="mt-1 text-xs text-slate-500">
              {note.length} caractere · minim 5 caractere pentru a confirma
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={saving}
            data-testid="rework-resolve-cancel"
          >
            Renunță
          </Button>
          <Button
            onClick={onConfirm}
            disabled={saving || note.trim().length < 5}
            className="bg-emerald-600 hover:bg-emerald-700 text-white"
            data-testid="rework-resolve-confirm"
          >
            {saving ? "Se rezolvă..." : "Confirmă & Retrimite BO"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
